import { Injectable } from "@angular/core";
import { of, Observable } from "rxjs";
import { ApiService } from '@core/services/api.service';
import {
  IBusinessExportDataSetting,
  IGoogleSheetAccessToken,
  IParamsDeleteSettingColumn,
  IParamsGenerateAuthURL,
  IParamsLoadSettingExportData,
  IParamsLoadSpreadSheets,
  IParamsRevokeToken,
  IParamsSaveSettingExportDataColumns
} from '@shared/models/business';
import { IResponseApi, ISelectOption } from '@core/models';
import { uriConsts } from '@shared/constants';



type IResMesRecord = Record<string | 'unknown' | 'invalidGrant', any>


/**
 * Service xử lý dữ liệu Google Sheet
 * @author admin
 * */
@Injectable({
  providedIn: 'any'
})
export class GoogleSheetService extends ApiService {

  /**
   *
   * */
  generateAuthURL(params: IParamsGenerateAuthURL) {
    return this.postRequest<IResponseApi<string>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_GENERATE_AUTH_URL, params
    );
  }


  /**
   *
   * */
  loadAccessTokens(businessId: number) {
    // TODO: Bỏ comment khi BE làm xong API googlesheetload để tránh lỗi 404
    return of({ code: 1, data: [] }) as unknown as Observable<IResponseApi<IGoogleSheetAccessToken[]>>;
    /*
    return this.postRequest<IResponseApi<IGoogleSheetAccessToken[]>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=loadAccessTokens`, {
      tab: 'loadAccessTokens',
      businessId
    }
    );
    */
  }

  /**
   *
   * */
  revokeAccessToken(params: IParamsRevokeToken) {
    return this.postRequest<IResponseApi>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=revokeAccessToken`, {
      tab: 'revokeAccessToken',
      ...params
    }
    );
  }

  /**
   *
   * */
  loadSettingColumns(params: IParamsLoadSettingExportData) {
    // TODO: Bỏ comment khi BE làm xong API googlesheetload để tránh lỗi 404
    return of({ code: 1, data: [] }) as unknown as Observable<IResponseApi<IBusinessExportDataSetting[]>>;
    /*
    return this.postRequest<IResponseApi<IBusinessExportDataSetting[]>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=loadSettingColumns`, {
      tab: 'loadSettingColumns',
      ...params
    }
    );
    */
  }

  /**
   *
   * */
  saveSettingColumn(params: IParamsSaveSettingExportDataColumns) {
    return this.postRequest<IResponseApi<IBusinessExportDataSetting, IResMesRecord>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=saveSettingColumn`, {
      tab: 'saveSettingColumn',
      ...params,
      columns: JSON.stringify(params.columns),
      configs: JSON.stringify(params.configs)
    }
    );
  }

  /**
   *
   * */
  deleteSettingColumn(params: IParamsDeleteSettingColumn) {
    return this.postRequest<IResponseApi>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=deleteSettingColumn`, {
      tab: 'deleteSettingColumn',
      ...params
    }
    );
  }


  /**
   * - Func kiểm tra xem file có tồn tại không, nếu có thì trả về kèm sheet
   *
   *      + Kiểm tra file google sheet của user có hợp lệ không
   *      + Nếu hợp lệ thì trả về sheets trong file
   */
  checkSpreadId(params: IParamsLoadSpreadSheets) {
    return this.postRequest<IResponseApi<{
      spreadId: string,
      sheets: ISelectOption[]
    }, Record<string, any>>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=checkSpreadId`, {
      tab: 'checkSpreadId',
      ...params
    }
    );
  }

  checkSpreadDataImport(params: any) {
    return this.postRequest<IResponseApi<{
      spreadId: string,
      totalItems: number,
      totalPages: number,
      headersFinal: Record<string, string>
    }, Record<string, any>>>(
      uriConsts.business.MANAGE_GOOGLE_SHEET_LOAD + `?tab=checkSpreadDataImport`, {
      tab: 'checkSpreadDataImport',
      ...params
    }
    );
  }

}
